/**
 * Users API endpoints
 */
import { apiClient } from '../api-client';
import { UserProfile, UpdateProfileRequest, Review, UserStats, UserSettings } from '@/types/user';

export const usersAPI = {
  /**
   * Get current user's profile
   */
  getProfile: () =>
    apiClient.get<UserProfile>('/api/users/me'),


  /**
   * Get user profile by ID
   */
  getProfileById: (userId: string) =>
    apiClient.get<UserProfile>(`/api/users/${userId}`),

  /**
   * Update user profile
   */
  updateProfile: (data: UpdateProfileRequest) =>
    apiClient.put<UserProfile>('/api/users/me', data),

  /**
   * Upload user avatar
   */
  uploadAvatar: (file: File) =>
    apiClient.postForm<{ message: string; avatar: string }>('/api/users/me/avatar', { file }),

  /**
   * Get user statistics
   */
  getStats: (userId?: string) =>
    apiClient.get<UserStats>(`/api/users/${userId || 'me'}/stats`),

  /**
   * Get user's reviews (as seller)
   */
  getReviews: (userId: string, page: number = 1, limit: number = 10) =>
    apiClient.get<{
      reviews: Review[];
      total: number;
    }>(`/api/users/${userId}/reviews`, {
      params: { page, limit },
    }),

  /**
   * Post a review for a seller
   */
  postReview: (sellerId: string, rating: number, comment: string, listingId?: string) =>
    apiClient.post<Review>(`/api/users/${sellerId}/reviews`, {
      rating,
      comment,
      listingId,
    }),

  /**
   * Get user's seller profile
   */
  getSellerProfile: (userId: string) =>
    apiClient.get(`/api/users/${userId}/seller`),

  /**
   * Get user's activity
   */
  getActivity: (page: number = 1, limit: number = 20) =>
    apiClient.get('/api/users/activity', {
      params: { page, limit },
    }),

  /**
   * Get current user's settings from backend
   */
  getSettings: () =>
    apiClient.get<UserSettings>('/api/users/settings'),

  /**
   * Update current user's settings
   */
  updateSettings: (settings: Partial<UserSettings>) =>
    apiClient.put<UserSettings>('/api/users/settings', settings),
};

